import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const FIELDS = [
  { name: 'name', label: 'Your Name', type: 'text', placeholder: 'John Doe' },
  { name: 'email', label: 'Email Address', type: 'email', placeholder: 'john@example.com' },
  { name: 'subject', label: 'Subject', type: 'text', placeholder: 'Product Inquiry' },
];

const emptyForm = { name: '', email: '', subject: '', message: '' };

export const ContactForm = () => {
  const [formData, setFormData] = useState(emptyForm);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: 'Message sent!',
      description: "Thank you for contacting us. We'll get back to you soon.",
    });
    setFormData(emptyForm);
  };

  return (
    <div className="bg-gray-50 rounded-lg p-6 sm:p-8">
      <form onSubmit={handleSubmit} className="space-y-6">
        {FIELDS.map((field) => (
          <div key={field.name}>
            <label htmlFor={field.name} className="block text-sm font-medium text-gray-700 mb-2">
              {field.label}
            </label>
            <input
              type={field.type}
              id={field.name}
              name={field.name}
              value={formData[field.name]}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#7B1E2B] focus:border-transparent transition-all"
              placeholder={field.placeholder}
            />
          </div>
        ))}

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="5"
            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#7B1E2B] focus:border-transparent transition-all resize-none"
            placeholder="Tell us how we can help you..."
          />
        </div>

        <button
          type="submit"
          className="w-full flex items-center justify-center gap-2 bg-[#001B2A] text-white py-4 rounded-md hover:bg-[#7B1E2B] transition-all duration-300 font-semibold shadow-lg hover:shadow-xl"
        >
          <Send className="h-5 w-5" />
          SEND MESSAGE
        </button>
      </form>
    </div>
  );
};
